export default "__VITE_ASSET__DVvXL7nl__"